import React, { useState } from 'react'
import Link from 'next/link'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image, ImageStyles, carLoading } from 'Components/view-image'
import dynamic from 'next/dynamic'
import TryCatchRender from 'Components/try-catch-render'
import FontSize10 from 'Components/font-size-10'
const RadarChart = dynamic(() => import('Components/radar-charts-new'), {
  ssr: false,
})
const Stars = dynamic(() => import('./stars'), {
  ssr: false,
})

const star = require('static/yellow-star.png')
const star_black = require('static/black-star-little.png')

interface ISeriesReview {
  comfort_score: number
  appearance_score: number
  configuration_score: number
  control_score: number
  power_score: number
  space_score: number
  interiors_score: number
  score: number
}

export interface ICarReview {
  series_id: number
  series_name: string
  author_info: {
    user_id: number
    user_name: string
    avatar_url: string
    auth_info: string
  }
  related_group_id: {
    group_count: number
    group_list: [string]
  }
  cover_url: string
  score: number
  content: string
  comfort_score: number
  appearance_score: number
  configuration_score: number
  control_score: number
  power_score: number
  space_score: number
  interiors_score: number
  is_new_energy: boolean // 是否是新能源
  series_type: number //车系类型 0 轿车 1 suv 2 mvp
  car_name: string //车型名称
  year: number
  top?: string
  right?: string
  rank?: number // 分页页数
  item_rank?: number // list 排序
  total_review_count: number
  series_review: ISeriesReview
  group_id_str: string
}

interface IConfig {
  appearance_score: number
  power_score: number
  control_score: number
  comfort_score: number
  space_score: number
  configuration_score: number
  interiors_score: number
  score: number
  [key: string]: number
}

export default TryCatchRender(function ValueCard(props: ICarReview) {
  const {
    score,
    author_info,
    series_name,
    series_id,
    content,
    cover_url,
    appearance_score,
    power_score,
    control_score,
    comfort_score,
    space_score,
    configuration_score,
    interiors_score,
    related_group_id,
    car_name,
    rank,
    item_rank,
    total_review_count,
    year,
    series_review,
    group_id_str: group_id,
  } = props

  const scoreObj: IConfig = {
    appearance_score,
    power_score,
    control_score,
    comfort_score,
    space_score,
    configuration_score,
    interiors_score,
    score,
  }

  const scorePartial = score / 500.0

  const review_detail_url = `/article/${group_id}`
  const car_profile_url = `/auto/series/${series_id}`
  const author_profile_url = `/user/ugc_profile/${author_info?.user_id}`

  const [showStatus, setShowStatus] = useState(false)

  return (
    <div className="card">
      <div
        className="top-card-bg"
        onMouseEnter={() => {
          setTimeout(() => {
            setShowStatus(true)
          }, 140)
        }}
        onMouseLeave={() => {
          setTimeout(() => {
            setShowStatus(false)
          }, 200)
        }}
      >
        <Link href={car_profile_url}>
          <a
            target="_blank"
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'dscore_module_item_card',
                car_series_id: `${series_id}`,
                car_series_name: series_name,
                group_id: `${group_id}`,
                rank: `${rank}`,
                item_rank: `${item_rank}`,
                module_id: 'dscore_module',
              })
            }}
          >
            <div className="score-wrap">
              <p className="mark">
                {(series_review?.score / 100.0)?.toFixed(2)} <span>分</span>
              </p>
            </div>
            <p className="top-card-info">查看车型</p>
            <div className="top-bottom-wrap">
              <div className="car-cover">
                <Image
                  className="car-cover-img"
                  src={cover_url}
                  lazy={true}
                  width={300}
                  height={200}
                  alt={series_name}
                  cusDefaultImg={carLoading}
                />
              </div>
              <div className="top-car-name-wrap">
                <p className="card-title g-one-line-text">{series_name}</p>
                <p className="card-title-info g-one-line-text">
                  {total_review_count
                    ? `共${total_review_count}人评分`
                    : '暂无评分'}
                </p>
              </div>
            </div>
            <div className="chart-wrap">
              {showStatus && (
                <RadarChart
                  theStyle={{
                    height: '235px',
                    width: '210px',
                    margin: '0 auto',
                  }}
                  comfort_score={series_review?.comfort_score}
                  appearance_score={series_review?.appearance_score}
                  configuration_score={series_review?.configuration_score}
                  control_score={series_review?.control_score}
                  power_score={series_review?.power_score}
                  space_score={series_review?.space_score}
                  interiors_score={series_review?.interiors_score}
                  score={series_review?.score}
                  type={'home'}
                />
              )}
            </div>
          </a>
        </Link>
      </div>
      <div className="content-wrap">
        <div className="user-info-wrap">
          <Link href={author_profile_url}>
            <a
              target="_blank"
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  event_id: 'dscore_module_item_profile',
                  car_series_id: `${series_id}`,
                  car_series_name: series_name,
                  group_id,
                  rank,
                  item_rank,
                  module_id: 'dscore_module',
                })
              }}
            >
              <img
                className="avatar"
                alt={series_name}
                src={author_info?.avatar_url}
              />
            </a>
          </Link>
          <span className="user-info-wrap-text g-one-line-text">
            <Link href={author_profile_url}>
              <a
                target="_blank"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'dscore_module_item_profile',
                    car_series_id: `${series_id}`,
                    car_series_name: series_name,
                    group_id,
                    rank,
                    item_rank,
                    module_id: 'dscore_module',
                  })
                }}
              >
                <span className="author-name">
                  {`${author_info?.user_name} `}
                </span>
              </a>
            </Link>
          </span>
          <span className="car-name-before">点评车型</span>
        </div>
        <div className="car-name-and-score">
          <p className="car-name-wrap g-one-line-text">
            <Link href={car_profile_url}>
              <a
                target="_blank"
                className="car-name g-one-line-text"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'dscore_module_item_series',
                    car_series_id: `${series_id}`,
                    car_series_name: series_name,
                    group_id,
                    rank,
                    item_rank,
                    module_id: 'dscore_module',
                  })
                }}
              >
                {year ? `${year}款` : ''}
                {car_name}
              </a>
            </Link>
          </p>
          <p className="car-score">
            <span className="score">{(score / 100.0)?.toFixed(2)}</span>
            <FontSize10>分</FontSize10>
          </p>
          <p className="car-star">
            <div className="stars">
              <Stars
                starIcon={star}
                starVacantIcon={star_black}
                className="stars"
                score={score / 100.0}
                maxScore={5}
                starWidth={8}
                starHeight={8}
              />
            </div>
          </p>
        </div>
        <div className="third-line">
          <Link href={review_detail_url}>
            <a target="_blank">
              <p
                className="content"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'dscore_module_item_card',
                    car_series_id: `${series_id}`,
                    car_series_name: series_name,
                    group_id,
                    rank,
                    item_rank,
                    module_id: 'dscore_module',
                  })
                }}
              >
                {content}
              </p>
            </a>
          </Link>
        </div>
      </div>
      <style jsx>{ImageStyles}</style>
      <style jsx>
        {`
          .top-card-bg {
            position: relative;
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            width: 100%;
            height: 145px;
            background-image: url(${require('./static/score-bg.png')});
            background-repeat: no-repeat;
            background-position: right bottom 0;
            background-size: 313px 72px;
            transition: height 0.16s ease;
            cursor: pointer;
            overflow: hidden;
          }
          .top-card-bg:hover {
            height: 302px;
          }
          .top-card-bg:hover .chart-wrap {
            opacity: 1;
          }
          .chart-wrap {
            position: absolute;
            top: 18px;
            left: 0;
            right: 0;
            opacity: 0;
            cursor: pointer;
            transition-delay: 0.14s;
            transition: opacity 0.1s ease;
          }
          .top-card-info {
            position: absolute;
            right: 16px;
            top: 14px;
            font-size: 14px;
            color: #606370;
            z-index: 9;
          }
          .top-card-info:hover {
            color: #1f2129;
          }
          .top-card-info::after {
            content: '';
            width: 0;
            height: 0;
            margin-left: 5px;
            display: inline-block;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 5px solid #606370;
            transform: rotate(0);
            transition: all 0.16s ease;
          }
          .top-card-info:hover::after {
            border-left: 5px solid #1f2129;
          }
          .card-title-info {
            color: #1f2129;
          }
          .score-wrap {
            position: absolute;
            left: 0;
            bottom: 23px;
            width: 115px;
            height: 122px;
            background: url(${require('./static/new-car-bg.png')}) no-repeat 0 0 /
              cover;
          }
          .top-card-bg:hover .mark {
            opacity: 0;
          }
          .mark {
            font-family: DINAlternate;
            font-size: 36px;
            font-weight: bold;
            color: #1f2129;
            margin-left: 12px;
            margin-top: 12px;
            opacity: 1;
            transition: opacity 0.1s ease;
          }
          .mark span {
            position: absolute;
            font-size: 18px;
            font-weight: 500;
            color: #1f2129;
            margin-top: 18px;
            margin-left: 4px;
            font-family: PingFangSC;
          }
          .card-title {
            font-family: PingFangSC;
            font-size: 16px;
            font-weight: 600;
            color: #1f2129;
          }
          .card {
            width: 100%;
            border-radius: 2px;
            background-color: white;
            display: inline-block;
            vertical-align: top;
            height: 302px;
            position: relative;
            margin-bottom: 15px;
            background: #fff;
          }

          .content-wrap {
            padding-top: 12px;
            bottom: 0;
            margin: 0 16px;
            height: 156px;
            border-top: 1px solid #e6e8f2;
          }
          .user-info-wrap {
            text-overflow: ellipsis;
            position: relative;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.25;
            color: #1f2129;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            padding-bottom: 8px;
          }
          .auth-info {
            position: absolute;
            top: 22px;
            left: 21px;
            width: 85%;
            color: #979aa8;
            font-weight: normal;
            font-size: 12px;
          }
          .user-info-wrap-text {
            vertical-align: middle;
            display: inline-block;
            max-width: calc(100% - 82px);
          }
          .content-wrap .avatar {
            display: inline-block;
            margin-right: 6px;
            width: 24px;
            height: 24px;
            cursor: pointer;
            vertical-align: middle;
            border-radius: 50%;
            z-index: 9;
          }
          .author-name {
            font-size: 14px;
            font-weight: normal;
            padding-right: 4px;
          }
          .author-name,
          .car-name {
            cursor: pointer;
          }
          .ping {
            padding-left: 8px;
          }
          .ping:before {
            content: '';
            position: absolute;
            width: 2px;
            height: 2px;
            background: #606370;
            border-radius: 50%;
            margin: 12px 0 0 -6px;
          }

          .yellow-stars {
            position: absolute;
            overflow: hidden;
            height: 8px;
            width: ${Math.ceil(60 * scorePartial) + Math.floor(score / 100)}px;
            z-index: 1;
            font-size: 0;
            white-space: nowrap;
          }

          .star {
            width: 8px;
            height: 8px;
            object-fit: contain;
            margin-right: 1px;
          }
          .top-bottom-wrap {
            position: absolute;
            bottom: 5px;
            left: 12px;
            right: 0;
            @apply lg:tw-h-86 md:tw-h-72 tw-h-55;
          }
          .top-car-name-wrap {
            display: inline-block;
            padding-left: 8px;
            vertical-align: middle;
            @apply tw-max-w-103 md:tw-max-w-124 lg:tw-max-w-139 xl:tw-max-w-169;
          }
          .car-cover {
            display: inline-block;
            vertical-align: middle;
            @apply lg:tw-w-129 lg:tw-h-86 md:tw-w-108 md:tw-h-72 tw-w-83 tw-h-55;
          }
          .car-name-wrap {
            display: inline-block;
            max-width: calc(100% - 46px);
            padding-bottom: 9px;
            font-size: 14px;
            font-weight: 500;
            vertical-align: top;
          }
          @media screen and (min-width: 1680px) {
            .car-name-wrap {
              max-width: calc(100% - 96px);
            }
          }
          .car-score {
            text-align: center;
            display: inline-block;
            margin-top: 4px;
            height: 15px;
            width: 46px;
            line-height: 15px;
            font-size: 12px;
            border-radius: 2px;
            @apply tw-bg-common-black xl:tw-bg-white tw-text-common-yellow xl:tw-text-common-black;
          }
          .car-score .score {
            font-family: DINAlternate;
            font-size: 12px;
            font-weight: bold;
            padding-left: 2px;
          }
          .car-score :global(.text-wrapper) {
            vertical-align: text-bottom;
          }
          .car-star {
            display: inline-block;
            width: 50px;
            @apply tw-hidden xl:tw-inline-block;
          }
          .car-star .stars {
            padding-top: 7px;
          }
          :gloabl(.top-card-wrap .car-cover-img) {
            cursor: pointer;
            transform: scaleX(-1);
          }

          .quoter {
            width: 20px;
            height: 20px;
            object-fit: contain;
            opacity: 0.6;
            margin-right: 2px;
            vertical-align: bottom;
          }
          .car-name-before {
            border-radius: 2px;
            background-color: rgba(0, 168, 96, 0.1);
            width: 76.8px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            color: #00a860;
            font-size: 16px;
            transform: scale(0.625);
            display: inline-block;
            margin-right: -10px;
            margin-left: -15px;
            vertical-align: top;
          }
          .car-name {
            font-size: 14px;
            color: #1f2129;
            padding-right: 4px;
          }
          .content {
            font-size: 14px;
            line-height: 1.5;
            color: #606370;
            max-height: 88px;
            -webkit-line-clamp: 3;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipse;
            cursor: ${group_id === '' ? 'auto' : 'pointer'};
            word-break: break-all;
          }
        `}
      </style>
    </div>
  )
})
